<div class="logo">
  <ng-content select="[logo]">
    <img alt="Apiz" fill ngSrc="assets/iupics/img/logo-apiz.svg" />
  </ng-content>
</div>

@if (!noMessage()) {
  <div class="content">
    <div class="message">
      <ng-content select="[message]">
        <span>{{ message() | translate }}</span>
      </ng-content>
    </div>

    <div class="actions">
      <!-- Call to actions like buttons to navigate, refresh etc... -->
      <ng-content select="[action]">
        <button class="p-button-primary" pButton type="button" (click)="defaultAction()">
          <!-- TODO: translate -->
          {{ (askForRefresh() ? 'generic.refresh' : 'status-page.returnToDashboard') | translate }}
        </button>
      </ng-content>
    </div>
  </div>
}
